var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointMarkerGhosted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mapmarker / mapmarker-ghosted") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mapmarker-/-mapmarker-ghosted",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.508664,143.768531 C205.406765,81.8704307 305.763414,81.8704307 367.661514,143.768531 C429.559614,205.666631 429.559614,306.02328 367.661514,367.921381 L268.038025,467.544869 C261.160459,474.422436 250.00972,474.422436 243.132153,467.544869 L143.508664,367.921381 C81.6105641,306.02328 81.6105641,205.666631 143.508664,143.768531 Z",
    id: "Marker",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#676767",
    cx: 255.585089,
    cy: 256,
    r: 83
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointMarkerGhosted);
export default __webpack_public_path__ + "static/media/pointMarker_ghosted.d0f95ff19e440484f093334641bcd70f.svg";
export { ForwardRef as ReactComponent };